import { DatabasesPage } from './pages'
import { DATABASES_ROUTES } from './routes-typed'

export const databasesRoutesMap: Record<string, string> = {
  databases: DATABASES_ROUTES.databases.path,
}

export interface AppRoute {
  path: string
  component: React.ComponentType<any>
  exact?: boolean
}

export const databasesRoutes: AppRoute[] = [
  {
    path: databasesRoutesMap.databases,
    component: DatabasesPage,
    exact: true,
  },
]
